import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      toast.success("Welcome back");
      nav(data.role === "coach" ? "/coach" : "/dashboard");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-baseline gap-2 justify-center mb-10" data-testid="login-logo">
          <span className="font-heading font-black text-3xl uppercase">Gainline</span>
          <span className="font-heading font-black text-3xl text-[#FF3B30] uppercase">Performance</span>
        </Link>
        <div className="border border-[#262626] bg-[#121212] p-8">
          <h1 className="font-heading font-black uppercase text-3xl mb-1">Sign In</h1>
          <p className="text-sm text-[#A3A3A3] mb-8">Back to the grind.</p>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="font-heading uppercase tracking-widest text-xs">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="mt-2 rounded-none bg-[#0A0A0A] border-[#262626] focus-visible:ring-0 focus:border-[#FF3B30] h-11" />
            </div>
            <div>
              <Label htmlFor="password" className="font-heading uppercase tracking-widest text-xs">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="mt-2 rounded-none bg-[#0A0A0A] border-[#262626] focus-visible:ring-0 focus:border-[#FF3B30] h-11" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full rounded-none bg-[#FF3B30] hover:bg-[#D63026] font-heading uppercase tracking-widest font-bold h-11">
              {loading ? "Signing In…" : "Sign In"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-[#A3A3A3] text-center">
            No account? <Link to="/register" className="text-[#FF3B30] font-heading uppercase tracking-widest text-xs" data-testid="login-to-register">Register</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
